import { render, staticRenderFns } from "./index3.5.vue?vue&type=template&id=549dcadb&scoped=true"
import script from "./index3.5.vue?vue&type=script&lang=js"
export * from "./index3.5.vue?vue&type=script&lang=js"
import style0 from "./index3.5.vue?vue&type=style&index=0&id=549dcadb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549dcadb",
  null
  
)

export default component.exports